import type { UserCapability } from '@joyful/utils'
import { CurrentUserContext } from '../utils/currentUserContext'

interface HasCapabilityOptions {
  /**
   * if true, will run authz check on user capabilities, even if the user is a JOYFUL_ADMIN
   *
   * @default false
   */
  shouldCheckStrictCapabilities?: boolean
}

export type HasCapability = (
  capability: UserCapability,
  options?: HasCapabilityOptions,
) => boolean

export function useHasUserCapability(): HasCapability
export function useHasUserCapability(capability: UserCapability): boolean
export function useHasUserCapability(capability?: UserCapability) {
  const currentUser = CurrentUserContext.useSafeContext()

  const hasCapability: HasCapability = (
    _capability,
    { shouldCheckStrictCapabilities = false } = {},
  ) => {
    if (
      currentUser?.effective_role === 'JOYFUL_ADMIN' &&
      shouldCheckStrictCapabilities === false
    ) {
      return true
    }

    return currentUser?.capabilities.has(_capability) === true
  }

  return capability === undefined ? hasCapability : hasCapability(capability)
}
